// extracted by mini-css-extract-plugin
export default {"image":"lZ-z","loaded":"mZ-z"};